export default __webpack_public_path__ + "static/media/errrorY@2x.60ba49e5.png";